const en = {
  // Header Navigation
  nav: {
    about: "About",
    performance: "Performance",
    onboarding: "Onboarding",
    technology: "Technology",
    behindStrategy: "Strategy",
    pricing: "Pricing",
    faq: "FAQ",
    contact: "Contact",
    startOnboarding: "Start Onboarding",
  },

  // Hero Section
  hero: {
    badge: "Gold Automated Trading Bot",
    title: "A Simple and Smarter Way to",
    titleHighlight: "Access Trading Automation",
    description: "Connect once. Stay in control. Let OPTIMUS automation do the heavy lifting on GOLD (XAUUSD) markets with institutional-grade algorithmic precision.",
    quote: '"You always stay in control of your account and capital"',
    learnMore: "Learn More",
    features: {
      transparent: "Transparent Performance",
      support: "Ongoing Support",
      control: "Full Capital Control",
      community: "Exclusive Community",
    },
    stats: {
      years: "2.5+",
      yearsLabel: "Years in Operation",
      clients: "6,000+",
      clientsLabel: "Active Clients",
      global: "Global",
      globalLabel: "Worldwide Presence",
      capital: "US$ 12M+",
      capitalLabel: "Total Capital",
    },
  },

  // About Section
  about: {
    sectionTitle: "About",
    title: "What is",
    titleHighlight: "OPTIMUS",
    description: "OPTIMUS is a Gold trading bot (EA - Expert Advisor) that connect your trading account to our independent automated trading system to manage risk, remove human error, and build passive income.",
    cards: {
      automation: {
        title: "Automation Access",
        desc: "Access our automated system engineered for consistent performance in the gold market (XAUUSD) without manual trade execution from the user. Just let OPTIMUS work for you!\n\nEasy and simple onboarding process.",
      },
      transparency: {
        title: "Performance Transparency",
        desc: "View independently tracked strategy performance data via third-party verification platforms. Full transparency at all times.\n\nCheck our MYFXBOOK verified account.",
      },
      referral: {
        title: "Referral Programme",
        desc: "OPTIMUS offers discretionary referral rewards for people you introduce to the platform. Participation is fully optional.",
      },
    },
    comingSoon: "Coming Soon",
    faqLink: "Find more detailed information about OPTIMUS Gold Bot on the",
    faqLinkText: "FAQ section",
  },

  // Performance Section
  performance: {
    sectionTitle: "Performance",
    title: "Verified Strategy",
    titleHighlight: "Performance",
    description: "View account activity anytime. Updates are automatic and transparent, independently verified.",
    liveData: "Live Verified Data",
    cumulative: "Cumulative Performance",
    avgMonthly: "Avg Monthly Change",
    maxDrawdown: "Maximum Drawdown",
    tracked: "Independently Tracked",
    liveFeed: "Live Data Feed",
    winRate: "Win Rate",
    thisWeek: "This Week",
    thisMonth: "This Month",
    thisYear: "This Year",
    chartTitle: "Verified Monthly Performance Data",
    chartDisclaimer: "Past performance does not guarantee future results.",
    clientsTrades: "Clients Trades",
  },

  // How It Works / Onboarding Section
  howItWorks: {
    sectionTitle: "The Process",
    title: "Discover",
    titleHighlight: "OPTIMUS",
    titleEnd: "Onboarding",
    description: "Take a deeper look at how clients begin their journey with OPTIMUS Gold Bot.",
    steps: {
      step1: {
        title: "Create Broker Account",
        desc: "Broker Selection / Open Account / Setup Account & Fund\n\nWe offer a selection of different brokers that you can choose from to use with the bot. Full step-by-step instructions available.\n\nMinimum investment: €1,050 / US$1,050 / £850",
      },
      step2: {
        title: "Connect OPTIMUS",
        desc: "Once your account is open and ready, you can securely connect it to our service and let the automation do its job.",
      },
      step3: {
        title: "Automated Trading Begins",
        desc: "Once connected, trades execute automatically based on predefined rules and built-in risk controls. No manual trade execution required.\n\nEnjoy fully automated trading!!",
      },
      step4: {
        title: "Monitor Anytime",
        desc: "Check performance anytime and access all information about your account through app or broker's website. Everything is transparent and real-time.",
      },
    },
    supportIncluded: "Support Included",
    supportText: "When you click in START ONBOARDING button, you will be guided step-by-step through our onboarding process.\nNo technical setup is required. Everything is simple.\nYour money stays fully under your control at all times.",
  },

  // Technology Section
  technology: {
    sectionTitle: "Our Technology",
    title: "Built for",
    titleHighlight: "Consistency",
    description: "One system. Intelligent execution. Designed around specific operating principles for long-term performance.",
    features: {
      xauusd: { title: "XAUUSD (Spot Gold)", desc: "The strategy focuses exclusively on XAUUSD (spot gold) and is configured specifically for this market." },
      scalping: { title: "Fixed Scalping Strategy", desc: "Follows a predefined scalping approach focused on short-duration trades for consistent returns." },
      exposure: { title: "Short Market Exposure", desc: "Trades typically last minutes, limiting prolonged exposure to volatile market conditions." },
      ai: { title: "AI-Optimised Entry Logic", desc: "Entry conditions are generated using rule-based logic supported by machine-learning analysis and multiple technical inputs." },
      indicators: { title: "Multi-Indicator Confirmation", desc: "Trade signals are generated only when multiple technical indicators align for maximum precision." },
      protection: { title: "Built-in Protection", desc: "Multiple predefined safeguards designed to limit exposure and protect your capital." },
      drawdown: { title: "Equity Drawdown Protection", desc: "Predefined equity threshold at 30%, after which further trading is automatically restricted." },
      hedging: { title: "Automated Hedging Logic", desc: "Hedge orders generated automatically using predefined grid logic when specific conditions are met." },
      frequency: { title: "Selective Trade Frequency", desc: "Based on historical data, the strategy typically executes 2-4 trades per week for quality over quantity." },
    },
  },

  // Behind the Strategy Section
  behindStrategy: {
    sectionTitle: "Behind the Strategy",
    title: "What's Behind OPTIMUS",
    titleHighlight: "{rate}% Historical Win Rate",
    description: "OPTIMUS is built on disciplined execution, structured risk management, and data-driven market logic.",
    selectiveTrading: {
      title: "Selective Trading for Better Stability",
      desc1: "OPTIMUS does not trade every day. It trades only when its indicators and market conditions align. Some days are active, others may stay quiet.",
      desc2: "This is normal — OPTIMUS is built for long-term stability, and it comes with patience. This selective approach reduces unnecessary risk and contributes to long-term consistency.",
    },
    riskControl: {
      title: "Built-in Risk Control",
      items: ["No martingale", "No aggressive leverage", "Built for consistency", "Withdraw at any time"],
    },
    transparency: {
      title: "Real-Time Transparency, Full Control",
      desc: "Track every position, every trade, and every movement directly from your account through app or your portal's access.",
      highlight: "OPTIMUS gives you full visibility at all times.",
    },
    fluctuation: {
      title: "Your Balance Will Fluctuate, It's Normal",
      desc: "Floating P&L is normal in grid systems — it doesn't mean anything is wrong. OPTIMUS is simply managing its position.",
      italic: "What matters is the full cycle, not the daily noise.",
    },
    noIntervention: {
      title: "No Intervention Required",
      desc: "Once activated, the system operates on its own. No manual adjustments needed — just monitor if you want.",
    },
    whenNotTrade: {
      title: "When OPTIMUS",
      titleHighlight: "Chooses Not to Trade",
      marketConditions: { title: "Market Conditions Not Ideal", desc: "If volatility or structure isn't right, OPTIMUS waits. This protects your capital and avoids unnecessary exposure." },
      gridSetup: { title: "Grid Setup Not Optimal", desc: "The bot checks whether its grid can be deployed safely. If the structure is too wide or unstable, it chooses not to trade." },
      events: { title: "Events", desc: "After strong price movements or economic events, OPTIMUS pauses. It waits for the market to stabilise before re-engaging." },
    },
    cta: {
      title: "It's Never Too Late Unless You",
      titleHighlight: "Keep Waiting",
      desc: "Join thousands of people already using OPTIMUS today.",
      exclusive: "OPTIMUS is an institutional product being offered to the retail market for the first time.",
      exclusiveHighlight: "Don't miss this opportunity!",
      faqNote: "You may find more detailed information in the",
      faqLink: "FAQ section",
    },
  },

  // Pricing Section
  pricing: {
    sectionTitle: "Service Fee",
    title: "Clear. Fair.",
    titleHighlight: "Results-Linked.",
    description: "Fees apply only when net positive performance is recorded during the period.\nYou only pay for new profits.",
    performanceFee: "Performance Fee",
    serviceFee: "Service fee on net profits",
    minimumInvestment: "Minimum investment: €1,050 / US$1,050 / £850",
    additionalCost: "Additional cost: US$8.00/month Metacopier platform subscription.",
    benefits: {
      fee: { title: "30% Service Fee", desc: "A single fee on realised net profits, settled daily." },
      community: { title: "Exclusive Community", desc: "Access to exclusive community on Telegram." },
      resultsBased: { title: "Results-Based Only", desc: "No fees are charged unless net performance is positive." },
    },
  },

  // Testimonials Section
  testimonials: {
    sectionTitle: "Success Stories",
    title: "What Users Say About",
    titleHighlight: "OPTIMUS",
    items: [
      { name: "Sarah J.", role: "Verified Client", text: "I've tried multiple automated trading bots, but OPTIMUS is the only one that delivers consistent results without the stress. The daily updates are fantastic." },
      { name: "Michael C.", role: "Verified Client", text: "The transparency is what sold me. Being able to see the live results verified independently before depositing gave me total confidence. Best investment I've made this year." },
      { name: "Emma T.", role: "Verified Client", text: "Passive income was always a dream until I found OPTIMUS. Now my account grows while I focus on my business. The support team is also incredibly helpful." },
    ],
  },

  // FAQ Section
  faq: {
    sectionTitle: "FAQ",
    title: "Frequently Asked",
    titleHighlight: "Questions",
    description: "Everything you need to know about Optimus automated trading.",
    categories: {
      general: {
        title: "General Information",
        items: [
          { q: "What is Optimus and what does the automated strategy do?", a: "Optimus provides access to an automated trading strategy that connects to your brokerage account and executes trades based on a predefined algorithmic strategy. You do not need to manually place trades or analyze charts; the system operates autonomously once connected." },
          { q: "Do I need to do anything once the bot is active?", a: "No. Once active, the automation runs independently. The bot is fully automatic and will adjust everything on its own. You are free to monitor your broker account and manage your funds at any time." },
          { q: "What are the fees for using Optimus?", a: "There are no upfront costs or subscription fees — we only win if you win. A performance fee (profit-split) of 30% is automatically deducted from realized profits at the end of the trading day." },
        ],
      },
      security: {
        title: "Security & Fund Control",
        items: [
          { q: "Does Optimus handle or access my money?", a: "No. Optimus never holds or controls your funds. Your money stays in your own broker account, fully under your control. Optimus cannot move or withdraw your money." },
          { q: "Can I withdraw my money at any time?", a: "Yes. Since your funds remain in your personal broker account, you can withdraw them whenever you choose." },
        ],
      },
      strategy: {
        title: "Strategy & Performance",
        items: [
          { q: "What is the trading strategy?", a: "The bot was created by a talented team of veteran traders and cost around 7 figures in investment, and was developed in partnership with a Canadian asset manager. The OPTIMUS employs an advanced fixed scalping strategy with minimal market exposure. Through AI optimization, 13 custom indicators, and 7 protection mechanisms to select the most optimal entry points. Trading occurs during specific times based on historical patterns, ensuring consistency and risk limitation. With the built-in equity stop protector of 30%, capital remains safeguarded while the strategy capitalizes with short and efficient trades, lasting an average of 5 minutes. This unique combination of technology and risk management delivers exceptional profitability with limited market exposure. The bot will automatically add hedge orders on a grid system function, on other confluences based entry points." },
          { q: "What assets are traded?", a: "The strategy is specifically optimized for XAUUSD (Gold). While the bot is designed to work on other pairs, those will be released in the future." },
          { q: "How often does the bot trade?", a: "On average, the bot trades 3 to 4 times a week. It prioritizes quality over quantity, trading only during specific times and in safe market environments. If the market is unstable or major economic news is expected, Optimus will not trade." },
          { q: "Where can I see live performance?", a: "We prioritize transparency. You can view historical profits, drawdowns, and trade frequency through our public verified account on Myfxbook, a third-party platform for independent data tracking.", badge: "Coming Soon" },
        ],
      },
      risk: {
        title: "Risk Management",
        items: [
          { q: "How is risk managed?", a: "The system includes a built-in Equity Stop Protector of 30%. This means if a 30% drawdown is reached, trading stops automatically to safeguard your capital. Important to note that the bot has other 7 protection mechanisms taking small losses on unsuccessful entries. The 30% Equity Stop Protector mechanism is a last resort protection and is very rarely used." },
          { q: "Can I adjust my risk?", a: "Yes. While the default is 30%, you can adjust this limit at any time to suit your personal risk preferences." },
          { q: "Is past performance guaranteed?", a: "No. While the system averaged a 7.8% monthly return in 2025, past performance is not a reliable indicator of future results. Trading involves significant risk to your capital." },
        ],
      },
      setup: {
        title: "Setup & Compatibility",
        items: [
          { q: "Which brokers can I use?", a: "Optimus partners with three regulated brokers to ensure secure integration. You must open a new account exclusively using the official Optimus links provided during onboarding to ensure the automation's risk settings are configured correctly." },
          { q: "What leverage is required?", a: "A minimum leverage of 1:200 (up to 1:500) is required. Standard retail leverage (1:30) is insufficient for this strategy to operate." },
          { q: "Can I use this with a Prop Firm?", a: "No. Optimus is not natively designed for Prop Firm accounts. Any attempt to use it for this purpose is done at the user's own risk." },
          { q: "What is the minimum investment?", a: "The minimum investment to start using OPTIMUS is €1,050 / US$1,050 / £850. This amount is required to ensure the strategy operates effectively with appropriate risk management." },
        ],
      },
    },
  },

  // Footer
  footer: {
    description: "Automated Gold Trading System. Connect once. Stay in control. Let automation do the heavy lifting on XAUUSD markets.",
    quickLinks: "Quick Links",
    legal: "Legal",
    legalLinks: {
      privacy: "Privacy Policy",
      terms: "Terms of Service",
      risk: "Risk Disclosure",
      cookie: "Cookie Policy",
    },
    instagramCommunity: "Confraria do Trader Community",
    copyright: "OPTIMUS. All rights reserved.",
    riskWarning: "Risk Warning: Trading gold and forex involves significant risk. Past performance is not indicative of future results. Only trade with capital you can afford to lose.",
  },

  // Contact Section
  contact: {
    sectionTitle: "Contact",
    title: "Get in",
    titleHighlight: "Touch",
    description: "Have questions about OPTIMUS? We're here to help. Fill out the form below and our team will get back to you as soon as possible.",
    form: {
      name: "Your Name",
      namePlaceholder: "Enter your full name",
      email: "Email Address",
      emailPlaceholder: "Enter your email",
      message: "Message",
      messagePlaceholder: "How can we help you?",
      submit: "Send Message",
    },
    successMessage: "Thank you for your message! We will get back to you soon.",
    errorMessage: "Error sending message. Please try again.",
  },

  // Client Trades Page
  clientTrades: {
    sectionTitle: "Transparency",
    title: "Client Trade Activity",
    titleHighlight: "Examples",
    description: "Examples of live trade execution from accounts connected to the automated trading system.",
    disclaimer: "Screenshots are provided for transparency and demonstration purposes only. Individual account activity and outcomes will vary.",
    backToHome: "Back to Home",
    copyright: "OPTIMUS. All rights reserved.",
    riskWarning: "Risk Warning: Trading gold and forex involves significant risk. Past performance is not indicative of future results. Only trade with capital you can afford to lose.",
  },

  // Language Selector
  languageSelector: {
    en: "English",
    pt: "Português",
  },

  // Get Access Page
  getAccess: {
    backToHome: "Back to Home",
    sectionTitle: "Get Access",
    title: "Onboarding &",
    titleHighlight: "Activation Process",
    description: "Follow the steps below to activate the OPTIMUS automated trading system on your account.",
    disclaimerTitle: "Read Before Joining",
    disclaimerText: "Before you start, please make sure you carefully read all disclaimers. These disclaimers outline how OPTIMUS works, the requirements for access, and the rules that must be followed. Trading forex involves significant risk. Only trade with capital you can afford to lose.",
    chooseBroker: "Choose Your Broker",
    chooseBrokerDesc: "Open your account with your chosen broker using the provided link.",
    chooseBrokerNote: "It is not possible to create an account directly on the broker's website. To gain access to OPTIMUS, you must register using the official link provided above.",
    regCtaTitle: "Ready to start the onboarding process?",
    regCtaDesc: "Register so we can guide you through each step and send you instructions by email.",
    regCtaButton: "I want to activate OPTIMUS",
    regFormTitle: "Start Onboarding Process",
    regFormDesc: "Enter your details so we can track and support your activation process.",
    regFormNamePlaceholder: "Full name",
    regFormEmailPlaceholder: "Email",
    regFormBrokerLabel: "Selected broker:",
    regFormSubmit: "Confirm and Start",
    regFormSubmitting: "Registering...",
    regSuccessTitle: "Process started successfully!",
    regSuccessDesc: "Check your email — we've sent a guide with important information to complete each step.",
    regAlreadyTitle: "You're already registered!",
    regAlreadyDesc: "Your onboarding process was already started. Continue with the steps below.",
    openAccount: "Open Account",
    step1Title: "Create Your Account",
    selectBrokerPrompt: "Select a broker above to see the step-by-step instructions.",
    openAccountAt: "Open Account (Official Link)",
    progressSteps: ["Broker", "Setup", "Fund", "Test", "Activation", "Copier"],
    brokers: {
      vantage: {
        step1Instructions: [
          "Open the link and create your account using your email and password.",
          "Input your country.",
          "Leave the \"REFERRED BY\" field blank.",
          "Accept the terms and click \"Create Account\".",
        ],
        step1Emails: "",
        step1EmailItems: [],
        step1Download: "You can download the MetaTrader 5 app from the broker's website:",
        step1DownloadButton: "Download MetaTrader 5",
        step2Desc: "After starting the account opening process and entering your personal information, you need to configure the settings listed below:",
        step2Emails: "After completing the account opening, you will receive confirmation emails from Vantage, including:",
        step2EmailItems: [
          "Email to confirm your email address.",
          "Email with your MetaTrader 5 login credentials.",
        ],
        step2ConfigItems: [
          "Platform: MetaTrader 5",
          "Account Type: RAW ECN",
          "Minimum Leverage: 1:300",
        ],
        step3Desc: "Log in to access your account, click on \"Deposit\" or \"Funds\".",
        step3ExtraItems: [
          "Confirm the account that will receive the deposit.",
          "Enter the desired amount for the deposit.",
          "Choose your preferred transfer method.",
          "Review that your deposit details are correct and finalize the deposit.",
        ],
      },
      vtmarkets: {
        step1Instructions: [
          "Open the link and create your account using your email and password.",
          "Input your country.",
          "Leave the \"REFERRED\" field blank.",
          "Click \"Open a live Account\".",
        ],
        step1Emails: "",
        step1EmailItems: [],
        step1Download: "You can download the MetaTrader 5 app from the broker's website:",
        step1DownloadButton: "Download MetaTrader 5",
        step1DownloadNote: "Find MetaTrader 5 platform and click \"START NOW\".",
        step2ConfigItems: [
          "Platform: MetaTrader 5",
          "Account Type: RAW ECN (Or Standard STP depending on your country - Both valid)",
          "Minimum Leverage: 1:300",
        ],
        step2Desc: "After starting the account opening process and entering your personal information, you need to configure the settings listed below:",
        step2Emails: "After completing the account opening, you will receive confirmation emails from VT Markets, including:",
        step2EmailItems: [
          "Email to confirm your email address.",
          "Email with your MetaTrader 5 login credentials.",
        ],
        step3Desc: "Log in to access your account, click on \"Deposit\" or \"Funds\".",
        step3ExtraItems: [
          "Confirm the account that will receive the deposit.",
          "Enter the desired amount for the deposit.",
          "Choose your preferred transfer method.",
          "Review that your deposit details are correct and finalize the deposit.",
        ],
      },
      puprime: {
        step1Instructions: [
          "Open the link and create your account using your email and password.",
          "Input your country.",
          "Leave the \"REFERRED BY\" field blank.",
          "Accept the terms and click \"Create Account\".",
        ],
        step1Emails: "",
        step1EmailItems: [],
        step1Download: "",
        step1DownloadButton: "",
        step2Desc: "After starting the account opening process and entering your personal information, you need to configure the settings listed below:",
        step2Emails: "After completing the account opening, you will receive confirmation emails from PU Prime, including:",
        step2EmailItems: [
          "Email to confirm your email address.",
          "Email with your MetaTrader 5 login credentials.",
        ],
        step2ConfigItems: [
          "Platform: MetaTrader 5",
          "Account Type: STANDARD",
          "Minimum Leverage: 1:300",
        ],
        step3Desc: "Log in to access your account, click on \"Deposit\" or \"Funds\".",
        step3ExtraItems: [
          "Confirm the account that will receive the deposit.",
          "Enter the desired amount for the deposit.",
          "Choose your preferred transfer method.",
          "Review that your deposit details are correct and finalize the deposit.",
        ],
      },
    },
    step2Title: "Set Up the Account",
    step2Desc: "After opening the account, configure the settings listed below:",
    step2ConfigTitle: "IMPORTANT SETTINGS:",
    step2Note: "Make sure all settings match the recommended configuration for optimal performance with OPTIMUS.",
    step3Title: "Fund the Account",
    step3Desc: "Log in to access your account and click on \"Deposit\" or \"Funds\".",
    step3InfoTitle: "IMPORTANT INFORMATION:",
    step3Items: [
      "Minimum deposit: €1,050 / $1,050 / £850",
      "The deposit must be made in a single transaction, without splitting.",
      "Maximum recommended capital per account: $25,000 (If you invest more capital, split it across multiple accounts).",
    ],
    step4Title: "Test Trade",
    step4QrLabel: "Scan the QR Code with your phone camera to download MetaTrader 5:",
    step4QrCaption: "Opens automatically on App Store or Google Play",
    step4Desc: "After depositing your funds, you need to verify that your account is set up correctly and ready for activation.\nTo do that, you will need to place a confirmation test trade.\nFollow these steps:",
    step4Steps: [
      "Download and install MetaTrader 5 App on your phone.",
      "Open MetaTrader 5 and select EURUSD pair.",
      "Place a buy or sell order on this pair with a lot size of 1.0.",
      "Let the trade run for 15 to 30 seconds, then close it.",
      "Take a screenshot of the closed test trade to be submitted in step 05.",
    ],
    step4Note1: "You may have a small profit or loss during this process, but it will not significantly affect your balance.",
    step4Note2: "This step is important to properly enable your account.",
    step4Note3: "After this step, you will be almost ready to start and will be activated soon!",
    step4GuideButton: "Access Detailed Guide",
    step4GuideSoon: "Coming Soon",
    step4ImportantTitle: "IMPORTANT INFORMATION:",
    step4ImportantItems: [
      "In the MetaTrader 5 App you can follow operations in real time and all information regarding the account and balance.",
      "Never manually trade on your account connected to the robot. This may cause the robot to malfunction.",
    ],
    step5Title: "Submit Information for Activation",
    step5Desc: "Submit the following confirmation information to proceed with activation:",
    step5Items: [
      "Full name",
      "Account ID number",
      "Attach the screenshot of your confirmation test trade",
    ],
    step5Important: "Make sure the screenshot photo is CLEAR so we can carry out the necessary verification and AVOID DELAYS.",
    step5FormName: "Full Name",
    step5FormNamePlaceholder: "Enter your full name",
    step5FormEmail: "Email Registered at the Broker",
    step5FormEmailPlaceholder: "Enter the email registered at the broker",
    step5FormBrokerName: "Chosen Broker Name",
    step5FormBrokerNamePlaceholder: "E.g.: Vantage, VT Markets, PU Prime",
    step5FormAccountId: "Account ID Number",
    step5FormAccountIdPlaceholder: "Enter your account ID",
    step5FormScreenshot: "Closed Test Trade Screenshot",
    step5FormScreenshotBtn: "Choose File",
    step5FormSubmit: "Submit Confirmation",
    step5FormSubmitting: "Submitting...",
    step5FormSuccess: "Confirmation submitted successfully! We will review your information and activate your account shortly.",
    step5FormError: "Error submitting. Please try again.",
    step6Badge: "Final Step",
    step6Title: "MetaCopier Setup",
    step6Intro: "Now that your account has been approved and activated, we need to connect it to OPTIMUS.",
    step6Desc: "In this final step, we will set up the \"bridge\" that carries orders from our system to your account, so that our strategy's trades are replicated in your account in real time. For this, we use a market-leading platform that ensures you receive the trades made by the OPTIMUS account in the same millisecond, with the lowest latency possible.",
    step6Email: "After your account is activated in step 05, you will receive an exclusive email with the subject: \"Setup Instructions - Metacopier & OPTIMUS\" containing detailed instructions to configure Metacopier.",
    step6After: "Once you complete this step, your account will automatically replicate OPTIMUS trades.",
    step6CostLabel: "Costs",
    step6CostText: "Metacopier charges a separate subscription of US$8.00 per month for the use of their services.",
    step6Help: "Have any questions? Feel free to reach out through the form on our website, via email at info@optimusgoldbot.com, or through the Confraria do Trader Instagram DM. Good luck!",
    needHelp: "Need help?",
    needHelpText: "Contact us at",
    riskWarning: "Risk Warning: Trading gold and forex involves significant risk. Past performance is not indicative of future results. Only trade with capital you can afford to lose.",
  },
};

export default en;
